import { useContext } from 'react'

import DaiChatPanelSizeContext from 'contexts/DaiChatPanelSizeContext'
import { PANEL_WIDTH } from 'layouts/Main/components/DaiChatPanel/styles'

const useDaiChatPanelSize = () => {
  const context = useContext(DaiChatPanelSizeContext)

  return {
    panelWidth: context?.panelWidth ?? PANEL_WIDTH,
    setPanelWidth: context?.setPanelWidth ?? (() => {}),
  }
}

export default useDaiChatPanelSize
